import { get, sync } from 'vuex-pathify';
export default {
  computed: {
    isSelectionActive: sync('tools/toolStatus@isSelectionActive'),
    isSqlQueryModuleEnabled: get('admin/additionalModules@SQL.enabled'),
    clearSelectionButton() {
      return {
        name: 'clearSelection',
        icon: '$unselection',
        tooltip: this.isAnyFeatureSelected
          ? this.$i18n.t('button.clearSelection')
          : this.$i18n.t('button.noObjectsSelected', { suffix: '' }),
        disabled: !this.isAnyFeatureSelected,
      };
    },
    selectAllRowsButton() {
      return {
        name: 'selectAllRows',
        icon: 'mdi-checkbox-multiple-marked',
        tooltip: this.isAllRowsSelected ? '' : this.$i18n.t('button.selectAll'),
        disabled: this.isAllRowsSelected,
        fontSize: '19px',
      };
    },
    selectionButton() {
      return {
        name: 'selection',
        tooltip: this.isSelectionActive
          ? this.$i18n.t('button.selectionOff')
          : this.isActiveToolNotReplaceable
          ? this.$i18n.t('button.oneToolActive')
          : this.$i18n.t('button.selectOnMapOrTable'),
        hasState: true,
        isActive: this.isSelectionActive,
      };
    },
    selectionBadgeNumber() {
      return this.isAnyFeatureSelected ? this.currentLayerSelectedFeatures.length : 0;
    },
    selectionMenuItems() {
      return [
        {
          name: 'single',
        },
        ...(this.hasGeometry
          ? [
              {
                name: 'multiple',
              },
              {
                name: 'freehand',
              },
              {
                name: 'polygon',
              },
              {
                name: 'radius',
              },
              ...(this.isSqlQueryModuleEnabled
                ? [
                    {
                      name: 'sqlQuery',
                    },
                  ]
                : []),
            ]
          : []),
      ];
    },
    zoomToSelectedButton() {
      return this.hasGeometry
        ? [
            {
              name: 'zoomToSelected',
              icon: 'mdi-magnify',
              tooltip: this.isAnyFeatureSelected
                ? this.$i18n.t('button.zoomToSelected')
                : this.$i18n.t('button.noObjectsSelected', { suffix: this.$i18n.t('button.noFeaturesToZoom') }),
              fontSize: '19px',
              disabled: !this.isAnyFeatureSelected,
            },
          ]
        : [];
    },
  },
  data: () => ({
    isSqlQueryDialogVisible: false,
    isSqlQueryDialogLoaded: false,
  }),
  methods: {
    openSqlQueryDialog() {
      this.isSqlQueryDialogLoaded = true;
      this.isSqlQueryDialogVisible = true;
    },
  },
};
